// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TreeSunlight__demo___N6h1c {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 8px;
    padding: 8px 4px 4px;
    color: rgba(91, 71, 38, 0.9);
    font-family: "Share Tech Mono", monospace;
}

.TreeSunlight__scene___OHup4 {
    position: relative;
    isolation: isolate;
    box-sizing: border-box;
    width: min(100%, 390px);
    height: 350px;
    overflow: hidden;
    border-radius: 8px;
    background: #182718;
    box-shadow: inset 0 0 42px rgba(14, 24, 13, 0.44), 0 9px 25px rgba(30, 27, 20, 0.3);
}

.TreeSunlight__canopyBase___qqRQc,
.TreeSunlight__canopyMid___fESTp,
.TreeSunlight__canopyNearLeft___HU2tg,
.TreeSunlight__canopyNearRight___viPxQ,
.TreeSunlight__canopyNearTop___kXibg,
.TreeSunlight__canopyGustLeft___wQEHI,
.TreeSunlight__canopyGustRight___FcvNJ,
.TreeSunlight__canopyDapple___nTSbe,
.TreeSunlight__canopyDappleAlt___yKTGp {
    position: absolute;
    display: block;
    inset: -7%;
    width: 114%;
    height: 114%;
    background-position: center 12%;
    background-repeat: no-repeat;
    background-size: cover;
    pointer-events: none;
    transform-origin: 52% 35%;
    will-change: transform, opacity;
}

.TreeSunlight__canopyBase___qqRQc {
    z-index: 0;
    background-image: var(--tree-sunlight-base);
}

.TreeSunlight__canopyMid___fESTp {
    z-index: 2;
    background-image: var(--tree-sunlight-mid);
    opacity: 0.42;
    animation: TreeSunlight__canopyMidSway___LiRHm 17s ease-in-out -6s infinite;
}

.TreeSunlight__canopyNearLeft___HU2tg,
.TreeSunlight__canopyNearRight___viPxQ,
.TreeSunlight__canopyNearTop___kXibg {
    z-index: 3;
    background-image: var(--tree-sunlight-near);
    opacity: 0.34;
}

.TreeSunlight__canopyNearLeft___HU2tg {
    clip-path: polygon(0 0, 27% 0, 24% 100%, 0 100%);
    animation: TreeSunlight__canopyNearLeftSway___QxLmQ 10.8s cubic-bezier(0.42, 0, 0.22, 1) -2.4s infinite;
}

.TreeSunlight__canopyNearRight___viPxQ {
    clip-path: polygon(73% 0, 100% 0, 100% 100%, 76% 100%);
    animation: TreeSunlight__canopyNearRightSway___P7uDL 13.2s cubic-bezier(0.42, 0, 0.22, 1) -6.8s infinite;
}

.TreeSunlight__canopyNearTop___kXibg {
    clip-path: polygon(0 0, 100% 0, 100% 18%, 0 18%);
    opacity: 0.5;
    animation: TreeSunlight__canopyNearTopSway___UBmFV 15.6s cubic-bezier(0.42, 0, 0.22, 1) -9.2s infinite;
}

.TreeSunlight__canopyGustLeft___wQEHI,
.TreeSunlight__canopyGustRight___FcvNJ {
    z-index: 4;
    background-image: var(--tree-sunlight-near);
    opacity: 0.08;
}

.TreeSunlight__canopyGustLeft___wQEHI {
    clip-path: polygon(0 0, 30% 0, 27% 100%, 0 100%);
    animation: TreeSunlight__canopyGustLeftMotion___R9q6v 22s cubic-bezier(0.42, 0, 0.22, 1) -7s infinite;
}

.TreeSunlight__canopyGustRight___FcvNJ {
    clip-path: polygon(70% 0, 100% 0, 100% 100%, 73% 100%);
    animation: TreeSunlight__canopyGustRightMotion___FxRqL 22s cubic-bezier(0.42, 0, 0.22, 1) -7s infinite;
}

.TreeSunlight__canopyDapple___nTSbe {
    z-index: 4;
    background-image: var(--tree-sunlight-dapple);
    opacity: 0.48;
    mix-blend-mode: screen;
    animation: TreeSunlight__dappleFlicker___dK5NB 7.8s ease-in-out -2.7s infinite;
}

.TreeSunlight__canopyDappleAlt___yKTGp {
    z-index: 4;
    background-image: var(--tree-sunlight-dapple);
    opacity: 0.34;
    mix-blend-mode: screen;
    animation: TreeSunlight__dappleFlickerAlt___kPFtF 11.4s ease-in-out -5.1s infinite;
}

.TreeSunlight__scene___OHup4::before,
.TreeSunlight__scene___OHup4::after {
    position: absolute;
    inset: 0;
    content: "";
    pointer-events: none;
}

.TreeSunlight__scene___OHup4::before {
    z-index: 7;
    background: radial-gradient(ellipse at 52% 37%, transparent 36%, rgba(5, 17, 9, 0.34) 100%);
}

.TreeSunlight__scene___OHup4::after {
    z-index: 9;
    background: linear-gradient(112deg, rgba(255, 255, 255, 0.04), transparent 34% 70%, rgba(4, 15, 7, 0.13));
}

.TreeSunlight__leafClusterCanvas___Ps5NF {
    position: absolute;
    z-index: 8;
    inset: -7%;
    display: block;
    width: 114%;
    height: 114%;
    pointer-events: none;
}

.TreeSunlight__dustLayer___LgfQQ {
    position: absolute;
    z-index: 10;
    inset: 0;
    pointer-events: none;
}

.TreeSunlight__dust___prwH9 {
    position: absolute;
    top: var(--dust-y);
    left: var(--dust-x);
    width: var(--dust-size);
    height: var(--dust-size);
    border-radius: 50%;
    background: rgba(255, 242, 190, 0.68);
    box-shadow: 0 0 4px rgba(255, 216, 112, 0.44);
    filter: blur(0.25px);
    mix-blend-mode: screen;
    animation: TreeSunlight__dustDrift___cKuYt var(--dust-duration) ease-in-out var(--dust-delay) infinite alternate;
}

.TreeSunlight__actions___onvIs {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
}

.TreeSunlight__replayButton___nA920,
.TreeSunlight__fullscreenButton___whyYv {
    border: 1px solid rgba(112, 82, 38, 0.3);
    border-radius: 5px;
    padding: 8px 13px;
    color: rgba(70, 49, 23, 0.92);
    background: rgba(255, 235, 180, 0.48);
    box-shadow: inset 0 1px rgba(255, 251, 225, 0.56), 0 3px 8px rgba(41, 29, 17, 0.12);
    cursor: pointer;
    font: inherit;
    font-size: 12px;
    letter-spacing: 0.03em;
    transition: background-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.TreeSunlight__replayButton___nA920:hover,
.TreeSunlight__fullscreenButton___whyYv:hover {
    background: rgba(255, 243, 202, 0.7);
    box-shadow: inset 0 1px rgba(255, 255, 239, 0.78), 0 4px 10px rgba(41, 29, 17, 0.18);
    transform: translateY(-1px);
}

.TreeSunlight__replayButton___nA920:focus-visible,
.TreeSunlight__fullscreenButton___whyYv:focus-visible {
    outline: 2px solid rgba(179, 124, 38, 0.76);
    outline-offset: 2px;
}

.TreeSunlight__demo___N6h1c:fullscreen {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    min-height: 100vh;
    padding: 0;
    overflow: hidden;
    background: #142115;
}

.TreeSunlight__demo___N6h1c:fullscreen .TreeSunlight__scene___OHup4 {
    flex: 0 0 auto;
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    border-radius: 0;
    box-shadow: none;
}

.TreeSunlight__demo___N6h1c:fullscreen .TreeSunlight__actions___onvIs,
.TreeSunlight__demo___N6h1c:fullscreen .TreeSunlight__dustLayer___LgfQQ {
    display: none;
}

@keyframes TreeSunlight__canopyMidSway___LiRHm {
    0%, 100% { transform: translate3d(-0.36%, 0.12%, 0) rotate(-0.04deg); }
    27% { transform: translate3d(0.28%, -0.1%, 0) rotate(0.03deg); }
    54% { transform: translate3d(0.52%, 0.14%, 0) rotate(0.06deg); }
    79% { transform: translate3d(-0.14%, -0.08%, 0) rotate(-0.03deg); }
}

@keyframes TreeSunlight__canopyNearLeftSway___QxLmQ {
    0%, 100% { transform: translate3d(-1.55%, 0.28%, 0) rotate(-0.16deg); }
    24% { transform: translate3d(0.34%, -0.18%, 0) rotate(0.05deg); }
    49% { transform: translate3d(1.9%, 0.16%, 0) rotate(0.2deg); }
    76% { transform: translate3d(0.24%, -0.26%, 0) rotate(-0.07deg); }
}

@keyframes TreeSunlight__canopyNearRightSway___P7uDL {
    0%, 100% { transform: translate3d(1.2%, -0.16%, 0) rotate(0.12deg); }
    26% { transform: translate3d(-0.42%, 0.24%, 0) rotate(-0.05deg); }
    53% { transform: translate3d(-2%, -0.1%, 0) rotate(-0.18deg); }
    79% { transform: translate3d(-0.2%, 0.2%, 0) rotate(0.04deg); }
}

@keyframes TreeSunlight__canopyNearTopSway___UBmFV {
    0%, 100% { transform: translate3d(-0.82%, -0.22%, 0) rotate(-0.09deg); }
    31% { transform: translate3d(0.46%, 0.15%, 0) rotate(0.05deg); }
    62% { transform: translate3d(1%, -0.13%, 0) rotate(0.1deg); }
    84% { transform: translate3d(-0.28%, 0.1%, 0) rotate(-0.04deg); }
}

@keyframes TreeSunlight__canopyGustLeftMotion___R9q6v {
    0%, 69%, 100% {
        transform: translate3d(-0.7%, 0.12%, 0) rotate(-0.06deg);
        opacity: 0.04;
    }
    77% {
        transform: translate3d(1.3%, 0.28%, 0) rotate(0.14deg);
        opacity: 0.15;
    }
    84% {
        transform: translate3d(2.8%, 0.56%, 0) rotate(0.26deg);
        opacity: 0.24;
    }
    92% {
        transform: translate3d(0.8%, 0.18%, 0) rotate(0.08deg);
        opacity: 0.1;
    }
}

@keyframes TreeSunlight__canopyGustRightMotion___FxRqL {
    0%, 69%, 100% {
        transform: translate3d(0.7%, -0.08%, 0) rotate(0.06deg);
        opacity: 0.04;
    }
    77% {
        transform: translate3d(-1.3%, 0.14%, 0) rotate(-0.12deg);
        opacity: 0.15;
    }
    84% {
        transform: translate3d(-2.8%, 0.38%, 0) rotate(-0.24deg);
        opacity: 0.24;
    }
    92% {
        transform: translate3d(-0.8%, 0.08%, 0) rotate(-0.07deg);
        opacity: 0.1;
    }
}

@keyframes TreeSunlight__dappleFlicker___dK5NB {
    0%, 100% { opacity: 0.35; transform: translate3d(-0.16%, 0.08%, 0); }
    18% { opacity: 0.58; transform: translate3d(0.13%, -0.1%, 0); }
    36% { opacity: 0.4; transform: translate3d(0.22%, 0.06%, 0); }
    58% { opacity: 0.66; transform: translate3d(-0.2%, -0.06%, 0); }
    76% { opacity: 0.43; transform: translate3d(-0.04%, 0.12%, 0); }
}

@keyframes TreeSunlight__dappleFlickerAlt___kPFtF {
    0%, 100% { opacity: 0.24; transform: translate3d(0.16%, -0.08%, 0); }
    21% { opacity: 0.46; transform: translate3d(-0.18%, 0.06%, 0); }
    48% { opacity: 0.28; transform: translate3d(0.1%, 0.14%, 0); }
    71% { opacity: 0.54; transform: translate3d(-0.13%, -0.1%, 0); }
}

@keyframes TreeSunlight__dustDrift___cKuYt {
    0% { transform: translate3d(-5px, 8px, 0) scale(0.72); opacity: 0.12; }
    47% { opacity: 0.54; }
    100% { transform: translate3d(8px, -13px, 0) scale(1.16); opacity: 0.72; }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"demo": `TreeSunlight__demo___N6h1c`,
	"scene": `TreeSunlight__scene___OHup4`,
	"canopyBase": `TreeSunlight__canopyBase___qqRQc`,
	"canopyMid": `TreeSunlight__canopyMid___fESTp`,
	"canopyNearLeft": `TreeSunlight__canopyNearLeft___HU2tg`,
	"canopyNearRight": `TreeSunlight__canopyNearRight___viPxQ`,
	"canopyNearTop": `TreeSunlight__canopyNearTop___kXibg`,
	"canopyGustLeft": `TreeSunlight__canopyGustLeft___wQEHI`,
	"canopyGustRight": `TreeSunlight__canopyGustRight___FcvNJ`,
	"canopyDapple": `TreeSunlight__canopyDapple___nTSbe`,
	"canopyDappleAlt": `TreeSunlight__canopyDappleAlt___yKTGp`,
	"canopyMidSway": `TreeSunlight__canopyMidSway___LiRHm`,
	"canopyNearLeftSway": `TreeSunlight__canopyNearLeftSway___QxLmQ`,
	"canopyNearRightSway": `TreeSunlight__canopyNearRightSway___P7uDL`,
	"canopyNearTopSway": `TreeSunlight__canopyNearTopSway___UBmFV`,
	"canopyGustLeftMotion": `TreeSunlight__canopyGustLeftMotion___R9q6v`,
	"canopyGustRightMotion": `TreeSunlight__canopyGustRightMotion___FxRqL`,
	"dappleFlicker": `TreeSunlight__dappleFlicker___dK5NB`,
	"dappleFlickerAlt": `TreeSunlight__dappleFlickerAlt___kPFtF`,
	"leafClusterCanvas": `TreeSunlight__leafClusterCanvas___Ps5NF`,
	"dustLayer": `TreeSunlight__dustLayer___LgfQQ`,
	"dust": `TreeSunlight__dust___prwH9`,
	"dustDrift": `TreeSunlight__dustDrift___cKuYt`,
	"actions": `TreeSunlight__actions___onvIs`,
	"replayButton": `TreeSunlight__replayButton___nA920`,
	"fullscreenButton": `TreeSunlight__fullscreenButton___whyYv`
};
module.exports = ___CSS_LOADER_EXPORT___;
